import { z } from 'zod';
import { UuidSchema } from '../common/ids.js';
import { PunchTypeSchema, ExceptionTypeSchema } from '../common/enums.js';
import { ErrorCodeSchema } from '../common/error-codes.js';
import { CapturedAtSchema, GpsSchema } from './punch.js';
import { GpsStatusSchema } from '../common/enums.js';
/**
 * `POST /punches/sync` batch item — a punch-in or punch-out payload with a
 * `type` discriminator (03-API-CONTRACT.md §3). `shiftId` is required only
 * for `IN` items, matching `PunchInRequestSchema`/`PunchOutRequestSchema`.
 */
export const SyncPunchItemSchema = z
    .object({
    type: PunchTypeSchema,
    clientPunchUuid: UuidSchema,
    shiftId: UuidSchema.optional(),
    deviceUuid: UuidSchema,
    capturedAt: CapturedAtSchema.optional(),
    gps: GpsSchema.optional(),
    gpsStatus: GpsStatusSchema.optional(),
})
    .refine((v) => (v.gps != null) !== (v.gpsStatus != null), {
    error: 'Exactly one of gps or gpsStatus must be provided',
    path: ['gps'],
})
    .refine((v) => v.type !== 'IN' || v.shiftId != null, {
    error: 'shiftId is required for IN items',
    path: ['shiftId'],
});
export const PunchSyncRequestSchema = z.object({
    punches: z.array(SyncPunchItemSchema).min(1),
});
const AcceptedResultSchema = z.object({
    clientPunchUuid: UuidSchema,
    status: z.literal('accepted'),
    punchId: UuidSchema,
    exceptionsRaised: z.array(ExceptionTypeSchema),
});
const DuplicateResultSchema = z.object({
    clientPunchUuid: UuidSchema,
    status: z.literal('duplicate'),
    punchId: UuidSchema,
});
const RefusedResultSchema = z.object({
    clientPunchUuid: UuidSchema,
    status: z.literal('refused'),
    code: ErrorCodeSchema,
    message: z.string().optional(),
});
/** Per-item sync result (04-PUNCH-ENGINE.md §6) — I-7: never silently lost. */
export const SyncResultItemSchema = z.discriminatedUnion('status', [
    AcceptedResultSchema,
    DuplicateResultSchema,
    RefusedResultSchema,
]);
export const PunchSyncResponseSchema = z.object({
    results: z.array(SyncResultItemSchema),
});
//# sourceMappingURL=sync.js.map